import React, { lazy } from "react";
import {
  ACCOUNT_REVIEW_MANAGER,
  ACCOUNT_REVIEW_PETTY_CASHIER,
  ACCOUNT_TITLE,
  ACCOUNT_TITLE_UPLOAD_EXCEL,
  ADD_PAYMENT_MANAGER,
  ADD_PAYMENT_PETTY_CASHIER,
  ADD_RECEIVE_MANAGER,
  ADD_RECEIVE_PETTY_CASHIER,
  BACKUP,
  COMPANIES_LIST,
  CONTACTS_BASE_ACTIVITY_REVIEW_PETTY_CASHIER,
  CONTACTS_ACTIVITY_REVIEW_PETTY_CASHIER,
  CONTACTS_ACTIVITY_REVIEW_MANAGER,
  CONTACTS_DETAIL_REVIEW_PETTY_CASHIER,
  CONTACTS_DETAIL_REVIEW_MANAGER,
  COST_CENTER,
  COST_CLASSIFICATION_DETAIL_MANAGER,
  COST_CLASSIFICATION_DETAIL_PETTY_CASHIER,
  COST_CLASSIFICATION_MANAGER,
  COST_CLASSIFICATION_PETTY_CASHIER,
  CREATE_DATA_MANAGER,
  CREATE_DATA_PETTY_CASHIER,
  DASHBOARD_MANAGER,
  DASHBOARD_PETTY_CASHIER,
  EDIT,
  EDIT_ACCOUNTING,
  EDIT_PAYMENT_MANAGER,
  EDIT_PAYMENT_PETTY_CASHIER,
  EDIT_RECEIVE_MANAGER,
  EDIT_RECEIVE_PETTY_CASHIER,
  FILES,
  INVITATION,
  MONTHLY_DETAIL_REVIEW_PETTY_CASHIER,
  MONTHLY_REVIEW_PETTY_CASHIER,
  MONTHLY_SELECT_REPORT_PETTY_CASHIER,
  MONTHLY_BUDGET_REVIEW_PETTY_CASHIER,
  NEW_OR_EDIT_COMPANY,
  PETTY_CASH_PETTY_CASHIER,
  PETTY_CASH_REPORTS_MANAGER,
  PETTY_CASH_REPORTS_PETTY_CASHIER,
  PRE_PAYMENT_MANAGER,
  PRE_PAYMENT_PETTY_CASHIER,
  PRE_RECEIVE_MANAGER,
  PRE_RECEIVE_PETTY_CASHIER,
  PROJECT_MEMBER_MANAGEMENT,
  PROJECT_MEMBER_PROFILE,
  PROJECT_SETTING,
  PROJECT_SETTING_ACCOUNTING_SOFTWARE,
  PROJECT_SETTING_BASIC_INFO,
  PROJECTS_MANAGEMENT,
  PURCHASE,
  SUMMARY_PAYMENT_MANAGER,
  SUMMARY_PAYMENT_PETTY_CASHIER,
  SUMMARY_PETTY_CASH_MANAGER,
  SUMMARY_PETTY_CASH_PETTY_CASHIER,
  SUMMARY_RECEIVE_MANAGER,
  SUMMARY_RECEIVE_PETTY_CASHIER,
  USER_ACCOUNT_SETTING,
  USER_ACCOUNT_SETTING_CHANGE_PASSWORD,
  USER_ACCOUNT_SETTING_EDIT,
  USER_ACCOUNT_SETTING_PAYMENTS_HISTORY,
  HASHTAG,
  HASHTAGS_SELECT_REPORT_PETTY_CASHIER,
  HASHTAGS_REVIEW_PETTY_CASHIER,
  HASHTAGS_ACTIVITY_REVIEW_PETTY_CASHIER,
  HASHTAGS_DETAIL_REVIEW_PETTY_CASHIER,
  TRANSACTIONS_IMPORT_EXCEL,
  CONTACT,
  PROJECT_SETTING_TRANSACTION_FORM,
  PROJECT_SETTING_PAYMENT_VALIDATION,
  TICKETS,
  TICKET,
  SHOW_TEAM,
  REORDER,
  LEVELS,
  VAT_REVIEW_REPORT_PETTY_CASHIER,
  VAT_REVIEW_REPORT_MANAGER,
  MY_TEAM_MEMBER_MANAGEMENT,
  INVITE,
  MEMBER_PROFILE,
  PROJECT_PROFILE,
  MONTHLY_BUDGET_PETTY_CASHIER,
  SUMMARY_MONTHLY_BUDGET_PETTY_CASHIER,
  PROJECT_MEMBER_EDIT_ACCOUNTING_CODES,
  SHARED_PROJECTS_MANAGEMENT,
  PETTY_CASH_BUDGET_REPORT_MANAGER,
  PETTY_CASH_BUDGET_MANAGER,
  PETTY_CASH_BUDGET_COPY_MANAGER,
  SUMMARY_PETTY_CASH_BUDGET_MANAGER,
  SUMMARY_PETTY_CASH_BUDGET_PETTY_CASHIER,
  CURRENT_PETTY_CASH_BUDGET_COMPARISON_REPORT_PETTY_CASHIER,
  SHOW_OWNER_USERS,
  ACCOUNT_TITLE_SUMMARY,
  HASHTAGS_SELECT_REPORT_MANAGER,
  HASHTAGS_REVIEW_MANAGER,
  HASHTAGS_ACTIVITY_REVIEW_MANAGER,
  HASHTAGS_DETAIL_REVIEW_MANAGER,
  TRASHED_PETTY_CASH_REPORTS_MANAGER,
  PROJECT_SETTING_CONNECT_TO_PARTNERS,
  PROJECT_SETTING_TRANSACTION_DAY_LIMIT,
  PROJECT_MEMBER_EDIT_IMPREST_PAYMENT_LIMIT
} from "../constants/urls";

import { Sidebar as AccountTitleSideBar } from "../containers/tools/accountTitle/sidebar";
import { Sidebar as CostCenterSidebar } from "../containers/tools/costCenter/sidebar";
import { Sidebar as HashtagSidebar } from "../containers/tools/hashtag/sidebar";
import { Sidebar as ContactSidebar } from "../containers/tools/contact/sidebar";

const PanelSelection = lazy(() => import("../containers/panelSelection"));
const PettyCashierDashboard = lazy(() =>
  import("../containers/dashboard/pettyCashier")
);
const ManagerDashboard = lazy(() => import("../containers/dashboard/manager"));
const CompanyList = lazy(() => import("../containers/projectList/index"));
const NewCompany = lazy(() => import("../containers/projectList/form"));
const PrePayment = lazy(() => import("../containers/prePayment"));
const PettyCashierCreateData = lazy(() =>
  import("../containers/createData/pettyCashier")
);
const ManagerCreateData = lazy(() =>
  import("../containers/createData/manager")
);
const PettyCashierPayment = lazy(() =>
  import("../containers/payment/pettyCashier")
);
const ManagerPayment = lazy(() => import("../containers/payment/manager"));
const PettyCashierAccountReview = lazy(() =>
  import("../containers/accountReview/pettyCashier")
);
const ManagerAccountReview = lazy(() =>
  import("../containers/accountReview/manager")
);

const PreReceive = lazy(() => import("../containers/preReceive"));
const PettyCashierReceive = lazy(() =>
  import("../containers/receive/pettyCashier")
);
const ManagerReceive = lazy(() => import("../containers/receive/manager"));

const PettyCashierCostClassification = lazy(() =>
  import("../containers/costClassification/pettyCashier")
);
const PettyCashierCostClassificationDetail = lazy(() =>
  import("../containers/costClassification/pettyCashier/detailPage")
);
const PettyCashierVatReviewReport = React.lazy(() =>
  import("../containers/vatReviewReport/pettyCashier")
);
const ManagerVatReviewReport = React.lazy(() =>
  import("../containers/vatReviewReport/manager")
);

const ManagerPettyCashBudgetReport = React.lazy(() =>
  import("../containers/pettyCashBudgetReport")
);
const ManagerPettyCashBudgetPreAdd = React.lazy(() =>
  import("../containers/pettyCashBudget/manager/preAdd")
);
const ManagerPettyCashBudgetAddEditForm = React.lazy(() =>
  import("../containers/pettyCashBudget/manager/addEdit")
);
const ManagerPettyCashBudgetCopyForm = React.lazy(() =>
  import("../containers/pettyCashBudget/manager/copy")
);
const ManagerPettyCashBudget = React.lazy(() =>
  import("../containers/pettyCashBudget/manager")
);

const PettyCashierPettyCashBudget = React.lazy(() =>
  import("../containers/pettyCashBudget/pettyCashier")
);
const PettyCashierCurrentPettyCashBudgetComparisonReport = React.lazy(() =>
  import("../containers/pettyCashBudget/pettyCashier/currentComparativeReport")
);

const ManagerCostClassification = lazy(() =>
  import("../containers/costClassification/manager")
);
const ManagerCostClassificationDetail = lazy(() =>
  import("../containers/costClassification/manager/detailPage")
);

const PettyCashierMonthlyReviewSelectReport = React.lazy(() =>
  import("../containers/monthlyReports/pettyCashier")
);
const PettyCashierMonthlyReview = React.lazy(() =>
  import("../containers/monthlyReports/pettyCashier/activity")
);
const PettyCashierMonthlyDetailReview = React.lazy(() =>
  import("../containers/monthlyReports/pettyCashier/detailReview")
);

const PettyCashierMonthlyBudgetList = React.lazy(() =>
  import("../containers/monthlyBudget/review")
);
const PettyCashierMonthlyBudgetAddEditForm = React.lazy(() =>
  import("../containers/monthlyBudget/addEdit")
);

const PettyCashierMonthlyBudget = React.lazy(() =>
  import("../containers/monthlyBudget")
);

const AccountTitle = lazy(() => import("../containers/tools/accountTitle"));
const AccountTitleSummary = lazy(() =>
  import("../containers/tools/accountTitle/summary")
);

const AccountTitleUploadExcel = lazy(() =>
  import("../containers/tools/accountTitle/importExcel")
);
const CostCenter = lazy(() => import("../containers/tools/costCenter"));

const ProjectSetting = lazy(() => import("../containers/projectSetting"));
const ProjectBasicInfo = lazy(() => import("../containers/projectBasicInfo"));
const PettyCash = lazy(() => import("../containers/pettyCash"));
const PettyCashierPettyCashReport = lazy(() =>
  import("../containers/pettyCashReport/pettyCashier")
);
const ManagerPettyCashReport = lazy(() =>
  import("../containers/pettyCashReport/manager")
);
const TrashedSequences = lazy(() =>
  import("../containers/pettyCashReport/manager/trashedSequence")
);
const ConnectToAccountingSoftware = lazy(() =>
  import("../containers/connectToAccountingSoftware")
);
const TransactionFormSetting = lazy(() =>
  import("../containers/transactionFormSetting")
);
const PaymentValidationSetting = lazy(() =>
  import("../containers/paymentValidationSetting")
);
const ConnectToPartners = lazy(() => import("../containers/connectToPartners"));
const TransactionDayLimit = lazy(() =>
  import("../containers/transactionDateLimit")
);

const PettyCashierPaymentSummery = React.lazy(() =>
  import("../containers/summary/payment/pettyCashier")
);
const ManagerPaymentSummery = React.lazy(() =>
  import("../containers/summary/payment/manager")
);
const PettyCashierReceiveSummery = React.lazy(() =>
  import("../containers/summary/receive/pettyCashier")
);
const ManagerReceiveSummery = React.lazy(() =>
  import("../containers/summary/receive/manager")
);

const PettyCashierPettyCashSummery = React.lazy(() =>
  import("../containers/summary/pettyCash/pettyCashier")
);
const ManagerPettyCashSummery = React.lazy(() =>
  import("../containers/summary/pettyCash/manager")
);
const File = React.lazy(() => import("../containers/file"));
const ImportExcel = React.lazy(() => import("../containers/importExcel"));
const Tickets = lazy(() => import("../containers/tickets"));
const ShowTicketThread = lazy(() =>
  import("../containers/tickets/showTicketThread")
);
const UserAccountSetting = React.lazy(() =>
  import("../containers/userAccountSetting")
);
const EditUserAccountSetting = React.lazy(() =>
  import("../containers/userAccountSetting/edit")
);
const ChangePassword = React.lazy(() =>
  import("../containers/userAccountSetting/changePassword")
);
const SharedContacts = React.lazy(() => import("../containers/sharedContacts"));
// const UserProfile = React.lazy(() => import("../containers/userProfile"));
const UserProfileAccountingEdit = React.lazy(() =>
  import("../containers/userProfile/accountingCode")
);
const Backup = React.lazy(() => import("../containers/backup"));
const Purchase = React.lazy(() => import("../containers/purchase"));

const MapsaInvitation = React.lazy(() =>
  import("../containers/tankhahgardanInvitation")
);
const PaymentHistory = React.lazy(() =>
  import("../containers/summary/premiumPlan")
);
const ProjectsManagement = React.lazy(() =>
  import("../containers/projectsManagement")
);

const ShowTeam = React.lazy(() => import("../containers/team"));
const TeamLevels = React.lazy(() => import("../containers/team/levels"));
const TeamSubItem = React.lazy(() => import("../containers/team/tools"));
const TeamLevelsReorder = React.lazy(() =>
  import("../containers/team/levels/level/reorder")
);

const Hashtag = React.lazy(() => import("../containers/tools/hashtag"));

const Contact = React.lazy(() => import("../containers/tools/contact"));

const PettyCashierHashtagSelectReport = React.lazy(() =>
  import("../containers/hashtagReports/pettyCashier")
);
const PettyCashierHashtagReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/pettyCashier/review")
);
const PettyCashierHashtagActivityReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/pettyCashier/activity")
);
const PettyCashierHashtagDetailReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/pettyCashier/detailReview")
);
const ManagerHashtagSelectReport = React.lazy(() =>
  import("../containers/hashtagReports/manager")
);
const ManagerHashtagReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/manager/review")
);
const ManagerHashtagActivityReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/manager/activity")
);
const ManagerHashtagDetailReviewReport = React.lazy(() =>
  import("../containers/hashtagReports/manager/detailReview")
);
const PettyCashierContactActivityReviewReport = React.lazy(() =>
  import("../containers/contactReports/pettyCashier/activity")
);
const ManagerContactActivityReviewReport = React.lazy(() =>
  import("../containers/contactReports/manager/activity")
);
const PettyCashierContactDetailReviewReport = React.lazy(() =>
  import("../containers/contactReports/pettyCashier/detailReview")
);
const ManagerContactDetailReviewReport = React.lazy(() =>
  import("../containers/contactReports/manager/detailReview")
);
const MyTeamMemberManagement = React.lazy(() =>
  import("../containers/teamManagement/myTeamMemberManagement")
);
const InviteMember = React.lazy(() =>
  import("../containers/teamManagement/inviteMember")
);
const ProjectMemberProfile = React.lazy(() =>
  import("../containers/teamManagement/inviteMember")
);
const MemberProfile = React.lazy(() =>
  import("../containers/teamManagement/memberProfile")
);
const ProjectProfile = React.lazy(() =>
  import("../containers/teamManagement/projectProfile")
);
const ProjectMemberEditAccountingCodes = React.lazy(() =>
  import(
    "../containers/teamManagement/projectMemberProfile/custodianView/accountingCode"
  )
);
const ProjectMemberEditImprestPayment = React.lazy(() =>
  import(
    "../containers/teamManagement/projectMemberProfile/custodianView/imprestPayment"
  )
);
const SharedProjects = React.lazy(() =>
  import("../containers/teamManagement/sharedProjects")
);
const OwnerUsers = lazy(() =>
  import("../containers/teamManagement/ownerUsers")
);

const routes = [
  {
    path: "/",
    component: PanelSelection,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  //PETTY_CASHIER
  {
    path: DASHBOARD_PETTY_CASHIER,
    component: PettyCashierDashboard,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: COMPANIES_LIST,
    component: CompanyList,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: NEW_OR_EDIT_COMPANY,
    component: NewCompany,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ACCOUNT_REVIEW_PETTY_CASHIER,
    component: PettyCashierAccountReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CREATE_DATA_PETTY_CASHIER,
    component: PettyCashierCreateData,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PRE_PAYMENT_PETTY_CASHIER,
    component: PrePayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ADD_PAYMENT_PETTY_CASHIER,
    component: PettyCashierPayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${EDIT_PAYMENT_PETTY_CASHIER}/:id`,
    component: PettyCashierPayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PRE_RECEIVE_PETTY_CASHIER,
    component: PreReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ADD_RECEIVE_PETTY_CASHIER,
    component: PettyCashierReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${EDIT_RECEIVE_PETTY_CASHIER}/:id`,
    component: PettyCashierReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_REPORTS_PETTY_CASHIER,
    component: PettyCashierPettyCashReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_PETTY_CASHIER,
    component: PettyCash,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${PETTY_CASH_PETTY_CASHIER}/:id`,
    component: PettyCash,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },

  {
    path: COST_CLASSIFICATION_PETTY_CASHIER,
    component: PettyCashierCostClassification,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: COST_CLASSIFICATION_DETAIL_PETTY_CASHIER,
    component: PettyCashierCostClassificationDetail,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: VAT_REVIEW_REPORT_PETTY_CASHIER,
    component: PettyCashierVatReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MONTHLY_SELECT_REPORT_PETTY_CASHIER,
    component: PettyCashierMonthlyReviewSelectReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MONTHLY_REVIEW_PETTY_CASHIER,
    component: PettyCashierMonthlyReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MONTHLY_DETAIL_REVIEW_PETTY_CASHIER,
    component: PettyCashierMonthlyDetailReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MONTHLY_BUDGET_REVIEW_PETTY_CASHIER,
    component: PettyCashierMonthlyBudgetList,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MONTHLY_BUDGET_PETTY_CASHIER,
    component: PettyCashierMonthlyBudgetAddEditForm,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${MONTHLY_BUDGET_PETTY_CASHIER}/:id`,
    component: PettyCashierMonthlyBudgetAddEditForm,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_MONTHLY_BUDGET_PETTY_CASHIER}/:id`,
    component: PettyCashierMonthlyBudget,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_SELECT_REPORT_PETTY_CASHIER,
    component: PettyCashierHashtagSelectReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_REVIEW_PETTY_CASHIER,
    component: PettyCashierHashtagReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_ACTIVITY_REVIEW_PETTY_CASHIER,
    component: PettyCashierHashtagActivityReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_DETAIL_REVIEW_PETTY_CASHIER,
    component: PettyCashierHashtagDetailReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_SELECT_REPORT_MANAGER,
    component: ManagerHashtagSelectReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_REVIEW_MANAGER,
    component: ManagerHashtagReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_ACTIVITY_REVIEW_MANAGER,
    component: ManagerHashtagActivityReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: HASHTAGS_DETAIL_REVIEW_MANAGER,
    component: ManagerHashtagDetailReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CONTACTS_ACTIVITY_REVIEW_PETTY_CASHIER,
    component: PettyCashierContactActivityReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CONTACTS_ACTIVITY_REVIEW_MANAGER,
    component: ManagerContactActivityReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CONTACTS_DETAIL_REVIEW_PETTY_CASHIER,
    component: PettyCashierContactDetailReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CONTACTS_DETAIL_REVIEW_MANAGER,
    component: ManagerContactDetailReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  //PETTY_CASHIER AND MANAGER
  {
    path: ACCOUNT_TITLE,
    component: AccountTitle,
    options: { sidebar: AccountTitleSideBar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${ACCOUNT_TITLE_SUMMARY}/:id`,
    component: AccountTitleSummary,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ACCOUNT_TITLE_UPLOAD_EXCEL,
    component: AccountTitleUploadExcel,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: COST_CENTER,
    component: CostCenter,
    options: { sidebar: CostCenterSidebar },
    layout: "tools.dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PROJECT_SETTING,
    component: ProjectSetting,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_BASIC_INFO,
    component: ProjectBasicInfo,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_ACCOUNTING_SOFTWARE,
    component: ConnectToAccountingSoftware,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_TRANSACTION_FORM,
    component: TransactionFormSetting,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_PAYMENT_VALIDATION,
    component: PaymentValidationSetting,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_CONNECT_TO_PARTNERS,
    component: ConnectToPartners,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_SETTING_TRANSACTION_DAY_LIMIT,
    component: TransactionDayLimit,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SUMMARY_PAYMENT_PETTY_CASHIER}/:id`,
    component: PettyCashierPaymentSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_RECEIVE_PETTY_CASHIER}/:id`,
    component: PettyCashierReceiveSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_PETTY_CASH_PETTY_CASHIER}/:id`,
    component: PettyCashierPettyCashSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: FILES,
    component: File,
    options: {},
    layout: "dashboard",
    visibility: "trust"
  },
  {
    path: TRANSACTIONS_IMPORT_EXCEL,
    component: ImportExcel,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: TICKETS,
    component: Tickets,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${TICKET}/:id`,
    component: ShowTicketThread,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: USER_ACCOUNT_SETTING,
    component: UserAccountSetting,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  {
    path: USER_ACCOUNT_SETTING_EDIT,
    component: EditUserAccountSetting,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: USER_ACCOUNT_SETTING_CHANGE_PASSWORD,
    component: ChangePassword,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_MEMBER_MANAGEMENT,
    component: SharedContacts,
    options: {},
    layout: "setting",
    visibility: "trust"
  },
  // {
  //   path: `${MEMBER_PROFILE}/:id`,
  //   component: UserProfile,
  //   options: {},
  //   layout: "fullpage",
  //   visibility: "trust"
  // },
  {
    path: `${PROJECT_MEMBER_PROFILE}/:projectId/:userId`,
    component: ProjectMemberProfile,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${PROJECT_MEMBER_PROFILE}/:id${EDIT_ACCOUNTING}`,
    component: UserProfileAccountingEdit,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: BACKUP,
    component: Backup,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PURCHASE,
    component: Purchase,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  // {
  //   path: "/user-account-setting/payments-history",
  //   component: AllPaymentHistory,
  //   options: {},
  //   layout: "fullpage",
  //   visibility: "trust"
  // },
  {
    path: INVITATION,
    component: MapsaInvitation,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${USER_ACCOUNT_SETTING_PAYMENTS_HISTORY}/:id`,
    component: PaymentHistory,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECTS_MANAGEMENT,
    component: ProjectsManagement,
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SHOW_TEAM}/:id`,
    component: ShowTeam,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SHOW_TEAM}/:id${LEVELS}`,
    component: TeamLevels,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SHOW_TEAM}/:teamId${LEVELS}${REORDER}`,
    component: TeamLevelsReorder,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: HASHTAG,
    component: Hashtag,
    options: { sidebar: HashtagSidebar },
    layout: "tools.dashboard",
    visibility: "trust"
  },
  {
    path: CONTACT,
    component: Contact,
    options: { sidebar: ContactSidebar },
    layout: "tools.dashboard",
    visibility: "trust"
  },
  //MANAGER
  {
    path: DASHBOARD_MANAGER,
    component: ManagerDashboard,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CREATE_DATA_MANAGER,
    component: ManagerCreateData,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PRE_PAYMENT_MANAGER,
    component: PrePayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PRE_RECEIVE_MANAGER,
    component: PreReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ADD_PAYMENT_MANAGER,
    component: ManagerPayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${EDIT_PAYMENT_MANAGER}/:id`,
    component: ManagerPayment,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_PAYMENT_MANAGER}/:id`,
    component: ManagerPaymentSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ADD_RECEIVE_MANAGER,
    component: ManagerReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${EDIT_RECEIVE_MANAGER}/:id`,
    component: ManagerReceive,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_RECEIVE_MANAGER}/:id`,
    component: ManagerReceiveSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: COST_CLASSIFICATION_MANAGER,
    component: ManagerCostClassification,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: COST_CLASSIFICATION_DETAIL_MANAGER,
    component: ManagerCostClassificationDetail,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_REPORTS_MANAGER,
    component: ManagerPettyCashReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: TRASHED_PETTY_CASH_REPORTS_MANAGER,
    component: TrashedSequences,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_PETTY_CASH_MANAGER}/:id`,
    component: ManagerPettyCashSummery,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: ACCOUNT_REVIEW_MANAGER,
    component: ManagerAccountReview,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: VAT_REVIEW_REPORT_MANAGER,
    component: ManagerVatReviewReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_BUDGET_REPORT_MANAGER,
    component: ManagerPettyCashBudgetReport,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_BUDGET_MANAGER,
    component: ManagerPettyCashBudgetPreAdd,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${PETTY_CASH_BUDGET_MANAGER}/:id`,
    component: ManagerPettyCashBudgetAddEditForm,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: PETTY_CASH_BUDGET_COPY_MANAGER,
    component: ManagerPettyCashBudgetCopyForm,
    layout: "dashboard",
    visibility: "trust" //all , guest , trust
  },
  {
    path: `${SUMMARY_PETTY_CASH_BUDGET_MANAGER}/:id`,
    component: ManagerPettyCashBudget,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: MY_TEAM_MEMBER_MANAGEMENT,
    component: MyTeamMemberManagement,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: INVITE,
    component: InviteMember,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${MEMBER_PROFILE}/:id`,
    component: MemberProfile,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${PROJECT_PROFILE}/:id`,
    component: ProjectProfile,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_MEMBER_EDIT_ACCOUNTING_CODES,
    component: ProjectMemberEditAccountingCodes,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: PROJECT_MEMBER_EDIT_IMPREST_PAYMENT_LIMIT,
    component: ProjectMemberEditImprestPayment,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: SHARED_PROJECTS_MANAGEMENT,
    component: SharedProjects,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SHOW_OWNER_USERS}/:ownerId`,
    component: OwnerUsers,
    options: {},
    layout: "fullpage",
    visibility: "trust"
  },
  {
    path: `${SUMMARY_PETTY_CASH_BUDGET_PETTY_CASHIER}/:id`,
    component: PettyCashierPettyCashBudget,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  },
  {
    path: CURRENT_PETTY_CASH_BUDGET_COMPARISON_REPORT_PETTY_CASHIER,
    component: PettyCashierCurrentPettyCashBudgetComparisonReport,
    layout: "fullpage",
    visibility: "trust" //all , guest , trust
  }
];
export default routes;
